import { fundServices } from '../../services/trading-services';

export const fundActions = {
    getCashInstructionEnquiry,
    getFundOrderCancel,
    cashDWAction,
    transferAction,
    transferEnquiryAction,
    queryCurrencyConversionAction,
    foreignExchangeAction,
    foreignExchangeEnquiryAction,
    cashDepositWithdrawalFeeEnquiryAction,
    withdrawableBalanceEnquiryAction,
    getFundMasterEnquiry,
}

function getCashInstructionEnquiry(params, callback) {
    return () => {
        fundServices.getCashInstructionEnquiry(params, res => {
            callback(res)
        })
    }
}
function getFundOrderCancel(params, callback) {
  return () => {
    if(params.transactionType==='D'){
      fundServices.getFundDepositOrderCancel(params, res => {
          callback(res)
      })
    }else{
      fundServices.getFundWithdrawalOrderCancel(params, res => {
        callback(res)
    })
    }
  }
}

function cashDWAction(params,callback) {
    return () => {
        if(params.pageID === '0'){
            fundServices.cashDepositService(params, res => {
                callback(res)
            })
        }else{
            fundServices.cashWithdrawalService(params, res => {
                callback(res)
            })
        }
    }
}

function transferAction(params,callback) {
    return () => {
        fundServices.transferService(params, res => {
            callback(res)
        })
    }
}

function transferEnquiryAction(params,callback) {
    return () => {
        fundServices.transferEnquiryService(params, res => {
            callback(res)
        })
    }
}

function queryCurrencyConversionAction(params,callback) {
    return () => {
        fundServices.queryCurrencyConversionService(params, res => {
            callback(res)
        })
    }
}

function foreignExchangeAction(params,callback) {
    return () => {
        fundServices.foreignExchangeService(params, res => {
            callback(res)
        })
    }
}

function foreignExchangeEnquiryAction(params,callback) {
    return () => {
        fundServices.foreignExchangeEnquiryService(params, res => {
            callback(res)
        })
    }
}

function cashDepositWithdrawalFeeEnquiryAction(params,callback) {
    return () => {
        fundServices.cashDepositWithdrawalFeeEnquiryService(params, res => {
            callback(res)
        })
    }
}

function withdrawableBalanceEnquiryAction(params,callback) {
    return () => {
        fundServices.withdrawableBalanceEnquiryService(params, res => {
            callback(res)
        })
    }
}

function getFundMasterEnquiry(params,callback) {
  return () => {
      fundServices.getFundMasterEnquiry(params, res => {
          callback(res)
      })
  }
}